// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","commentPopup":"CommentPopup__commentPopup--Ec","info":"CommentPopup__info--lW","text":"CommentPopup__text--Xu"};